import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'WaterFlowGroup';

export type WaterFlowGroupProps = {
  currentAggregateFlowRate?: number;
  aggregateVolumeLastPeriod?: number;
  changeFromPreviousPeriod?: number;
  aggregateVolumeCurrentPeriod?: number;
  cumulativeWaterFlow?: number;
  waterUsed?: number;
  availableWater?: number;
};

export class WaterFlowGroup extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  currentAggregateFlowRate?: number;
  aggregateVolumeLastPeriod?: number;
  changeFromPreviousPeriod?: number;
  aggregateVolumeCurrentPeriod?: number;
  cumulativeWaterFlow?: number;
  waterUsed?: number;
  availableWater?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      currentAggregateFlowRate: {
        type: 'Number',
        editable: true,
        label: 'Current Aggregate Flow Rate',
        name: 'currentAggregateFlowRate',
        description: 'Current Flow Rate for grouped Water Flow objects',
      },
      aggregateVolumeLastPeriod: {
        type: 'Number',
        editable: true,
        label: 'Aggregate Volume Last Period',
        name: 'aggregateVolumeLastPeriod',
        description: 'Aggregate water volume used last period for grouped Water Flow objects',
      },
      changeFromPreviousPeriod: {
        type: 'Number',
        editable: true,
        label: 'Change from previous period',
        name: 'changeFromPreviousPeriod',
        description: 'Change in volume used (l/m3/%) in last period to previous period(s)',
      },
      aggregateVolumeCurrentPeriod: {
        type: 'Number',
        editable: true,
        label: 'Aggregate Volume Current Period',
        name: 'aggregateVolumeCurrentPeriod',
        description: 'Aggregate water volume used current period for grouped Water Flow objects',
      },
      cumulativeWaterFlow: {
        type: 'Number',
        editable: true,
        label: 'Cumulative Water Flow (volume used)',
        name: 'cumulativeWaterFlow(volumeUsed)',
        description: 'Cumulative aggregate water volume used for grouped Water Flow objects',
      },
      waterUsed: { type: 'Number', editable: true, label: 'Water Used', name: 'waterUsed', description: 'Water used - current and by period' },
      AvailableWater: {
        type: 'Number',
        editable: true,
        label: 'Available Water',
        name: 'availableWater',
        description: 'Available Water - current and by period',
      },
    };
  };
}
